import { render, staticRenderFns } from "./SidebarTextButton.vue?vue&type=template&id=5aed1d6c&scoped=true&"
import script from "./SidebarTextButton.vue?vue&type=script&lang=js&"
export * from "./SidebarTextButton.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTextButton.vue?vue&type=style&index=0&id=5aed1d6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aed1d6c",
  null
  
)

export default component.exports